/// <amd-module name="ArtifactPolicy/Templates/TemplateSelectionTable" />
import React = require("react");

import { VssComponent, IVssComponentProperties, IVssComponentContext } from "VSS/Platform/Layout";
import { IObservableArray } from "VSS/Core/Observable";
import { localeFormat } from "VSS/Core/Util/String";
import { Checkbox } from "VSSUI/Checkbox";
import { IVssContributionService } from "VSS/Platform/Contribution";

import * as Resources from "ArtifactPolicy/Templates/Resources";
import { IArtifactPolicyTemplateContribution, IContributionWithId } from "ArtifactPolicy/Templates/Types";

export interface ITemplateSelectionTableProps extends IVssComponentProperties {
    contributionIds: string[];
    selectedContributionsObservable: IObservableArray<string>;
}

export class TemplateSelectionTable extends VssComponent<ITemplateSelectionTableProps, IVssComponentContext> {
    public render(): React.ReactNode {
        const contributionService = this.context.pageContext.getService<IVssContributionService>("IVssContributionService");
        const templateContributionItems: IContributionWithId[] = (this.props.contributionIds || []).map(cid => {
            return { id: cid, contribution: contributionService.getContribution<IArtifactPolicyTemplateContribution>(cid)! };
        });

        return (<div className={"templates-selection-table flex-column"}>
            <div>
                <div>{Resources.ChooseTemplates}</div>
                <div>{localeFormat("({0})", Resources.InputsInNextStep)}</div>
            </div>
            <div className={"margin-top-16"}>
                {templateContributionItems.map(this._getCheckboxUI)}
            </div>
        </div>);
    }

    private _getCheckboxUI = (contribution: IContributionWithId): JSX.Element => {
        const selected = this.props.selectedContributionsObservable.value.some(tid => tid === contribution.id);
        const labelId = "contribution-name-" + contribution.id;

        return (<Checkbox
            checked={selected}
            ariaLabelledBy={labelId}
            excludeTabStop={true}
            onChange={() => this._onTemplateSelectionChanged(contribution)}>
            <div className={"flex-column template-info"}>
                <div id={labelId} className={"font-weight-semibold padding-top-8"}>{contribution.contribution.displayName}</div>
                <div className={"secondary-text padding-bottom-8"}>{contribution.contribution.description}</div>
            </div>
        </Checkbox>);
    }

    private _onTemplateSelectionChanged = (tableItem: IContributionWithId) => {
        const selected = this.props.selectedContributionsObservable.value.some(tid => tid === tableItem.id);
        if (selected) {
            this.props.selectedContributionsObservable.removeAll(sid => sid === tableItem.id);
        }
        else {
            this.props.selectedContributionsObservable.push(tableItem.id);
        }
    }
}
